import { render, staticRenderFns } from "./RoundedTag.vue?vue&type=template&id=1cbbca0a&scoped=true"
import script from "./RoundedTag.vue?vue&type=script&lang=js"
export * from "./RoundedTag.vue?vue&type=script&lang=js"
import style0 from "./RoundedTag.vue?vue&type=style&index=0&id=1cbbca0a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cbbca0a",
  null
  
)

export default component.exports